module.exports = __webpack_public_path__ + "img/dread-nation.62989fd6.png";